<template>
  <v-app>
    <app-primary-nav />
    <app-toolbar />
    <v-content>
      <app-progress-bar />
      <app-flash-messages />
      <!-- Page content placed here -->
      <slot></slot>
      <app-footer />
      <app-auth-dialog />
      <pending-folder-dialog />
    </v-content>
    <app-user-nav />
    <app-notifications
      group="main"
      position="top right"
      :duration="3500"
      :animation="notificationAnimation"
    />
  </v-app>
</template>

<script>
  import AppPrimaryNav from '@/components/core/AppPrimaryNav'
  import AppToolbar from '@/components/core/AppToolbar'
  import AppProgressBar from '@/components/core/AppProgressBar'
  import AppFlashMessages from '@/components/core/AppFlashMessages'
  import AppUserNav from '@/components/core/AppUserNav'
  import AppFooter from '@/components/core/AppFooter'
  import AppAuthDialog from '@/components/core/AppAuthDialog'
  import PendingFolderDialog from '@/components/common/PendingFolderDialog'
  import AppNotifications from '@/components/core/AppNotifications.vue'

  export default {
    data () {
      return {
        notificationAnimation: {
          enter: {
            opacity: [1, 0],
            translateX: [0, -300],
            scale: [1, 0.2]
          },
          leave: {
            opacity: 0,
            height: 0
          }
        }
      }
    },
    components: {
      AppPrimaryNav,
      AppToolbar,
      AppProgressBar,
      AppFlashMessages,
      AppUserNav,
      AppFooter,
      AppAuthDialog,
      PendingFolderDialog,
      AppNotifications
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/layouts/Default.vue